// Sensei/common/schemas/collections/assessmentResults.js
import { z } from "zod";

const QuestionSchema = z.object({
    id: z.string(), // CHANGED: from .uuid() to just .string()
    questionText: z.string(),
    questionType: z.enum(['single-choice', 'multi-choice', 'text', 'drawing']),
    options: z.array(z.string()).optional(),
    correctAnswer: z.any().optional(),
    marks: z.number().int().positive(),
    timeLimitSeconds: z.number().int().positive().optional().nullable(),
});

const AnswerSchema = z.object({
    questionId: z.string(), // CHANGED: from .uuid() to just .string()
    answer: z.any(),
    isCorrect: z.boolean().optional().nullable(),
    score: z.number().optional().nullable(),
    feedback: z.string().optional().nullable(),
});

const AssessmentResultSchema = z.object({
    _id: z.string().optional(),
    studentId: z.string(),
    courseId: z.string(),
    topicId: z.string(),
    scheduleId: z.string(),
    
    status: z.enum(['not-started', 'in-progress', 'completed', 'grading', 'failed']).default('not-started'),
    
    questions: z.array(QuestionSchema).optional(),
    answers: z.array(AnswerSchema).optional().default([]),
    
    currentQuestionIndex: z.number().int().default(0),
    timeRemainingSeconds: z.number().int().optional().nullable(),

    finalScore: z.number().optional().nullable(),
    maxScore: z.number().optional().nullable(),

    startTime: z.coerce.date().optional().nullable(),
    endTime: z.coerce.date().optional().nullable(),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default AssessmentResultSchema;